import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import UsageHistoryHeader from "./usageheader/index";
import UsageHistorySubheader from "./usage-subheader/index";
import UsageHistoryBody from "./usagehistorytable/index";
var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class UsageHistory extends Component {
 
    constructor(props) {
        super(props);
        
        //this.state            = this.getInitialState();
        this.state = {
         
        };
      }

  componentDidMount() {
    
  }

  //Arrow function for renderLoader
 
  render() {
  
    return (
      <div> 
        <UsageHistoryHeader/>
        <UsageHistorySubheader/> 
        <UsageHistoryBody/>
      </div>
       
    );
  }
}


function mapStateToProps(state) {
  var { session, user } = state;
  return {
    session,
    user,
    deviceSize: state.deviceSize,
   
  };
}

export default connect(mapStateToProps, {  })(UsageHistory);
